import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { LoggingService } from '../shared/services/logging/logging.service';

@Component({
    template: '',
    standalone: false
})
export class AbstractNgModelComponent<T = any> implements ControlValueAccessor {
    @Input() public disabled: boolean;

    @Input() set value(value: T) {
        this.log.debug({ type: 'AbstractNgModelComponent:value:set', value });
        this._value = value;
        this.notifyValueChange(value);
    }

    get value(): T {
        return this._value;
    }

    protected _value: T;

    constructor(
        @Inject(LoggingService) protected log: LoggingService,
        protected cdRef: ChangeDetectorRef
    ) {}
    onChange: (value: T) => {};
    onTouched: () => {};
    onValidate: () => void;
    notifyValueChange(value: any): void {
        if (this.onChange) {
            this.onChange(value);
        }
    }
    writeValue(value: T): void {
        this.log.debug({ type: 'AbstractNgModelComponent:writeValue', value });
        this._value = value;
        setTimeout(() => this.cdRef.detectChanges(), 0);
    }
    registerOnChange(fn: any): void {
        this.log.debug({
            type: 'AbstractNgModelComponent:registerOnChange',
            fn
        });
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.log.debug({
            type: 'AbstractNgModelComponent:registerOnTouched',
            fn
        });
        this.onTouched = fn;
    }
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
